import { render } from "./PermissionGroupsList.vue?vue&type=template&id=1f0df34c&ts=true"
import script from "./PermissionGroupsList.vue?vue&type=script&lang=ts"
export * from "./PermissionGroupsList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__